import {
    Directive,
    OnDestroy,
    Input,
    Output,
    EventEmitter
  } from "@angular/core";
  import { Subject } from "rxjs";
  import {
    takeUntil,
    debounceTime,
    distinctUntilChanged,
    tap
  } from "rxjs/operators";
  
  @Directive()
  export abstract class AbstractDebounceDirective implements OnDestroy {
    @Input()
    public debounceTime: number;
  
    @Output()
    public onDebounceKeyUpEvent: EventEmitter<any>;
  
    protected emitEvent$: Subject<any>;
    protected subscription$: Subject<void>;
  
    constructor() {
      this.debounceTime = 300;
      this.onDebounceKeyUpEvent = new EventEmitter<any>();
      this.emitEvent$ = new Subject<any>();
      this.subscription$ = new Subject<void>();
    }
  
    ngOnInit(): void {
      this.emitEvent$
        .pipe(
          takeUntil(this.subscription$),
          debounceTime(this.debounceTime),
          distinctUntilChanged(),
          tap(value => this.emitChange(value))
        )
        .subscribe();
    }
  
    public emitChange(value: any): void {
      this.onDebounceKeyUpEvent.emit(value);
    }
  
    ngOnDestroy(): void {
      this.subscription$.next();
      this.subscription$.complete();
      this.emitEvent$.complete();
    }
  }
  